import React, { useEffect, useState } from 'react';
import { getNoteDisplayName } from '../utils/noteUtils';
import './NoteDisplay.css';

interface NoteDisplayProps {
  targetNote: string;
  isGameActive: boolean;
  flashColor?: 'green' | 'red' | null;
  isTransitioning?: boolean;
}

const NoteDisplay: React.FC<NoteDisplayProps> = ({ targetNote, isGameActive, flashColor, isTransitioning }) => {
  const [displayText, setDisplayText] = useState(targetNote);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (flashColor) {
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [flashColor]);

  useEffect(() => {
    // During transition, show empty when targetNote is cleared
    if (isTransitioning && !targetNote) {
      setDisplayText('');
    } else if (targetNote) {
      setDisplayText(targetNote);
    }
  }, [targetNote, isTransitioning]);
  if (!isGameActive) {
    return (
      <div className="note-display inactive">
        <p>Press Start to begin</p>
      </div>
    );
  }

  const displayNote = displayText ? getNoteDisplayName(displayText) : '';

  const isWaitingForNote = displayText === '';

  return (
    <div className={`note-display active ${isFlashing ? `flash-${flashColor}` : ''} ${isWaitingForNote ? 'waiting' : ''}`}>
      <div className="target-note">
        <h2>Play this note:</h2>
        <div className="note-name">
          {displayNote || (isWaitingForNote ? '-' : 'Loading...')}
        </div>
      </div>
    </div>
  );
};

export default NoteDisplay;